module.exports = __webpack_public_path__ + "img/nyyjs-1.3dbc072c.jpg";